import { render, staticRenderFns } from "./InfoManageSupplier.vue?vue&type=template&id=70bd14b7&scoped=true"
import script from "./InfoManageSupplier.vue?vue&type=script&lang=js"
export * from "./InfoManageSupplier.vue?vue&type=script&lang=js"
import style0 from "./InfoManageSupplier.vue?vue&type=style&index=0&id=70bd14b7&prod&lang=css"
import style1 from "./InfoManageSupplier.vue?vue&type=style&index=1&id=70bd14b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70bd14b7",
  null
  
)

export default component.exports